"use client";

import React from "react";
import { ArrowRight, Mail, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RedoAttSynasITrafiken() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="27643" id="skapa-ditt-drömbadrum" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-primary/10 rounded-lg blur-[120px] opacity-40" />
        
        {}
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
        <div className="absolute top-0 right-0 w-px h-full bg-gradient-to-b from-transparent via-primary/10 to-transparent" />
      </div>

      <div ref={ref} className={`container mx-auto px-4 relative z-10 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold tracking-tight text-white">
            Redo att förverkliga din <span className="text-primary">vision?</span>
          </h2>
          
          <p className="text-xl text-muted-foreground leading-relaxed font-default">Oavsett om du planerar ett funktionellt standardbadrum eller en mer exklusiv badrumsrenovering hjälper vi dig från första idé till färdigt badrum. Kontakta oss för att diskutera ditt projekt och få en tydlig offert utifrån dina önskemål och förutsättningar.</p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button asChild size="lg" className="w-full sm:w-auto text-base font-semibold bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-[0_0_30px_rgba(37,99,235,0.5)] transition-all duration-300">
              <Link to="/offertforfragan">
                Begär offert
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base border-primary/20 text-foreground hover:bg-primary/10 hover:text-primary hover:border-primary/50 transition-all duration-300">
              <Link to="/kontakta-oss">
                <Mail className="mr-2 h-5 w-5" />
                Kontakta oss
              </Link>
            </Button>
          </div>

          <div className="pt-8 flex items-center justify-center gap-6 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-lg bg-primary animate-pulse" />
              <span>Säker Vatten-auktoriserat</span>
            </div>
            <div className="w-1 h-1 rounded-lg bg-muted-foreground/30" />
            <div>Behöriga samarbetspartners</div>
          </div>
        </div>
      </div>
    </section>;
}